var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27994 24.6533V20.7599C7.27994 19.4666 8.29327 18.3066 9.73327 18.3066C11.0266 18.3066 12.1866 19.3199 12.1866 20.7599V24.5066C12.1866 27.1066 10.0266 29.2666 7.42661 29.2666C4.82661 29.2666 2.66661 27.0933 2.66661 24.5066V16.2933C2.51994 8.79994 8.43994 2.73328 15.9333 2.73328C23.4266 2.73328 29.3333 8.79994 29.3333 16.1466V24.3599C29.3333 26.9599 27.1733 29.1199 24.5733 29.1199C21.9733 29.1199 19.8133 26.9599 19.8133 24.3599V20.6133C19.8133 19.3199 20.8266 18.1599 22.2666 18.1599C23.5599 18.1599 24.7199 19.1733 24.7199 20.6133V24.6533",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.665e97b7a1955d8a014e7a1a9a47f628.svg";
export { ForwardRef as ReactComponent };